import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// TODO: Replace with your actual Firebase configuration
// Get this from Firebase Console > Project Settings > Your apps > Firebase SDK snippet
const firebaseConfig = {
  apiKey: "AIzaSyAKcyvtoSfH4lZbClNmIYZdRN_2gxpEuwc",
  authDomain: "alexapay.firebaseapp.com",
  projectId: "alexapay",
  storageBucket: "alexapay.firebasestorage.app",
  messagingSenderId: "661024085717",
  appId: "1:661024085717:web:6eadbb38ac5c6983efb45c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

export default app;
